/**
 * Status Pending Media Key Status.
 *
 * @group DRM
 *
 * @beta
 */
export const STATUS_PENDING = 'status-pending';
